import * as _ from 'underscore';

import ACTIONS from '../actions';
import { fakeSession } from '../calendar';

const sessionTree = (state = {}, action) => {
    function addSetKeys(data) {
        const setKeys = [];
        for (let i = 0; i < data.sets.length; i++) {
            setKeys.push(parseInt(data.sets[i]));
        }
        data.setKeys = setKeys;
        return data;
    }

    let newState = {};
    let data = null;
    let session = null;
    let keys = [];
    switch (action.type) {
        case ACTIONS.CALENDAR_ADD_PROGRAM_WORKOUTS:
            newState = { ...state };
            if (action.payload.entities.sessions) {
                Object.keys(action.payload.entities.sessions).forEach(key => {
                    const data = addSetKeys(
                        action.payload.entities.sessions[key]
                    );
                    newState[key] = {
                        programSubscription: false,
                        subscription: false,
                        type: 'workout',
                        data
                    };
                });
            }
            return newState;
        case ACTIONS.DAYS_CLEAR:
            return {};
        case ACTIONS.DAYS_RELOAD:
            newState = { ...action.payload.entities.sessions };
            Object.keys(newState).forEach(key => {
                const data = addSetKeys(newState[key].data);
                newState[key] = {
                    ...newState[key],
                    data
                };
            });
            return {
                ...state,
                ...newState
            };
        case ACTIONS.DND_CAL_SESSION:
            session = state[action.session.workout_id];
            session.data = {
                ...session.data,
                day: action.session.day,
                month: action.session.month,
                year: action.session.year,
                date: action.session.date,
                timeline_day: action.session.timeline_day
            };

            return {
                ...state,
                [action.session.workout_id]: session
            };
        case ACTIONS.SESSION_ADD:
            data = addSetKeys(action.session);
            newState = {
                ...state,
                [action.session.workout_id]: {
                    programSubscription: false,
                    subscription: false,
                    type: 'workout',
                    data
                }
            };
            return newState;
        case ACTIONS.SESSION_COPY:
            const newSession = {
                ...action.session,
                setKeys: _.pluck(action.session.sets, 'id'),
                sets: _.pluck(action.session.sets, 'id')
            };
            newState = {
                ...state,
                [action.session.workout_id]: {
                    programSubscription: false,
                    subscription: false,
                    type: 'workout',
                    data: newSession
                }
            };
            return newState;
        case ACTIONS.BLOCK_ADD:
            var sets = [];
            keys = [];
            if (action.order) {
                sets = action.session.sets;
                keys = action.session.setKeys;
            } else if (action.block.id !== null) {
                sets = [
                    ...state[action.session.workout_id].data.sets,
                    action.block.id
                ];
                keys = [
                    ...state[action.session.workout_id].data.setKeys,
                    action.block.key
                ];
            } else {
                sets = [
                    ...state[action.session.workout_id].data.sets,
                    action.block.id || action.block.key
                ];
                keys = [
                    ...state[action.session.workout_id].data.setKeys,
                    action.block.key
                ];
            }

            data = {
                ...state[action.session.workout_id].data,
                setKeys: keys,
                sets
            };

            newState = {
                ...state,
                [action.session.workout_id]: {
                    ...state[action.session.workout_id],
                    data
                }
            };
            return newState;
        case ACTIONS.BLOCK_DELETE:
            session = { ...action.session };

            var blocks = [];
            for (let i = 0; i < session.data.setKeys.length; i++) {
                if (session.data.setKeys[i] !== action.block.key) {
                    blocks.push(session.data.sets[i]);
                    keys.push(session.data.setKeys[i]);
                }
            }
            session.data.sets = blocks;
            session.data.setKeys = keys;
            session = {
                ...session
            };
            newState = {
                ...state,
                [session.data.workout_id]: session
            };
            return newState;
        case ACTIONS.SESSION_UPDATE:
            newState = {
                ...state,
                [action.session.workout_id]: {
                    ...state[action.session.workout_id],
                    data: {
                        ...action.session
                    }
                }
            };
            return newState;
        case ACTIONS.SESSION_DELETE:
            _.map(state, (s, k) => {
                k = parseInt(k, 10);
                if (k !== action.session.workout_id) {
                    return (newState[k] = s);
                }
            });
            return newState;
        case ACTIONS.SESSION_DELETE_UNDO:
            return {
                ...state,
                [action.session.data.workout_id]: { ...action.session }
            };
        case ACTIONS.CALENDAR_ADD_FAKE_SESSION:
            return {
                ...state,
                fakeSession
            };
        case ACTIONS.EXTRA_CLEAR:
            return {};
        default:
            return state;
    }
};

export default sessionTree;



// WEBPACK FOOTER //
// ./src/state/reducer/calendar/reducer/sessionTree.js